import { useEffect, useRef, useState } from "react";

export function useGoogleAdInterstitial({ adUnitPath, targeting, divId, size, shouldInitialize }) {
  const slotRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [adFilled, setAdFilled] = useState(false);

  useEffect(() => {
    if (!shouldInitialize) {
      return;
    }

    if (!window.googletag || !window.googletag.cmd) {
      setHasError(true);
      setIsLoading(false);
      return;
    }

    let renderEndedListener;
    let slotOnloadListener;

    window.googletag.cmd.push(() => {
      if (!window.googletag.pubadsReady) {
        window.googletag.pubads().enableSingleRequest();
        window.googletag.enableServices();
      }
    });

    window.googletag.cmd.push(() => {
      try {
        if (slotRef.current) {
          return;
        }

        const slot = window.googletag.defineSlot(adUnitPath, size, divId);

        if (!slot) {
          setHasError(true);
          setIsLoading(false);
          return;
        }

        if (targeting) {
          Object.entries(targeting).forEach(([key, value]) => {
            slot.setTargeting(key, value || "");
          });
        }

        slot.addService(window.googletag.pubads());

        renderEndedListener = (event) => {
          if (event.slot === slot && event.isEmpty) {
            setAdFilled(false);
            setHasError(true);
          }
        };

        slotOnloadListener = (event) => {
          if (event.slot === slot) {
            setAdFilled(true);

            try{
              const divElement = document.getElementById(divId);

              if (divElement && divElement.children && divElement.children[0]) {
                console.log(divElement.children[0])
                divElement.children[0].style = `border: 0pt; display: inline-block; width: ${window.document.body.offsetWidth}; height: ${window.document.body.offsetHeight}`;

                if(divElement.children[0].children[0]) {
                  divElement.children[0].children[0].width = window.document.body.offsetWidth;
                  divElement.children[0].children[0].height = window.document.body.offsetHeight;
                }
              }
            } catch(err) {
              console.error(err);
            }
          }
        };

        window.googletag.pubads().addEventListener("slotRenderEnded", renderEndedListener);
        window.googletag.pubads().addEventListener("slotOnload", slotOnloadListener);

        slotRef.current = slot;

        const checkAndDisplay = () => {
          const divElement = document.getElementById(divId);

          if (divElement) {
            window.googletag.display(divId);
            setIsLoading(false);
          } else {
            setTimeout(checkAndDisplay, 100);
          }
        };

        checkAndDisplay();
      } catch (e) {
        setHasError(true);
        setIsLoading(false);
      }
    });

    return () => {
      window.googletag.cmd.push(() => {
        if (renderEndedListener) {
          window.googletag.pubads().removeEventListener("slotRenderEnded", renderEndedListener);
        }
        if (slotOnloadListener) {
          window.googletag.pubads().removeEventListener("slotOnload", slotOnloadListener);
        }
        if (slotRef.current) {
          window.googletag.destroySlots([slotRef.current]);
          slotRef.current = null;
        }
      });
    };
  }, [shouldInitialize]);

  return { adContainerId: divId, isLoading, hasError, adFilled };
}